import axios from 'axios';
import { initMap } from './googleMaps';
import { Collapse } from 'bootstrap';

export default () => {
  const filtersContainer = document.querySelectorAll('form.real-estate-filters'),
        mainContainer = document.querySelector('.real-estate-posts-container.main');

  let mainCounter = document.querySelectorAll('.filter-icon-counter');

  if (!filtersContainer.length) {
    return;
  }

  const jumpToElement = (element) => {
    if (!element) {
      return;
    }

    const elementPosition = element.getBoundingClientRect().top + window.scrollY;
    const offsetPosition = elementPosition - 100;

    window.scrollTo({
      top: offsetPosition,
      behavior: "instant"
    });
  }
  
  function syncInputValues(input, forms) {
    forms.forEach((otherForm) => {
      let otherInput;

      if (input.type === 'radio' || input.type === 'checkbox') {
        const otherInputs = otherForm.querySelectorAll('input');
        otherInput = Array.from(otherInputs).find((oi) => oi.name === input.name && oi.value === input.value);
      } else {
        otherInput = otherForm.querySelector(`input[name="${input.name}"]`);
      }
  
      if (!otherInput) {
        return;
      }
  
      setInputValue(input, otherInput);
    });
  }

  function handleInputEvent(input, forms) {
    input.addEventListener('input', () => syncInputValues(input, forms));
  }


  function setInputValue(input, otherInput) {
      if (input.type === 'checkbox') {
          otherInput.checked = input.checked;
      } else {
          otherInput.value = input.value;
      }

      // input trigger change
      const event = new Event('change');
      otherInput.dispatchEvent(event);
  }

  filtersContainer.forEach(filtersC => {
    const singleFilters = filtersC.querySelectorAll('.filter-single'),
          resetBtn = filtersC.querySelector('.real-estate-filters-reset'),
          purposeField = filtersC.querySelector('form.real-estate-filters input[name="purpose-real-estate"]'),
          pageInputNumber = filtersC.querySelector('form.real-estate-filters input[name="paged"]'),
          sortField = filtersC.querySelector('form.real-estate-filters input[name="sort"]'),
          listingNavigation = document.querySelector('.real-estate-navigation'),
          btns = document.querySelectorAll('.real-estate-purpose'),
          sortSelect = document.querySelector('.real-estate-sort-select-wrapper select'),
          inputs = filtersC.querySelectorAll('input'),
          filtersCollapseElement = filtersC.querySelector('.filter-content');

    const filterCollapser = new Collapse(filtersCollapseElement, {toggle: false});


    document.body.addEventListener('click', e => {
      if (!e.target.closest('.real-estate-pagination-wrapper')) {
        return;
      }

      const item = e.target.closest('.page-numbers') ?? e.target;
  
      if (!item.classList.contains('page-numbers')) {
        return;
      }
  
      e.preventDefault();
      // get all query vars from page-numbers link
      const pageNumberLink = item.href;
      const pageString = pageNumberLink.split('/page/')[1];
      let pageNumber = Number(pageString?.match(/\d+/)[0] || 1);

      if (pageNumber < 1) {
        pageNumber = 1;
      }
        
      pageInputNumber.value = pageNumber; 
      
      ajaxRequest(filtersC)
        .then(() => jumpToElement(mainContainer))
        .catch((error) => console.error('An error occurred:', error));;
    });

    if (listingNavigation) {
      btns.forEach(btn => {
        btn.addEventListener('click', () => {
          purposeField.value = btn.value;

          ajaxRequest(filtersC);
        });
      });

      sortSelect.addEventListener('change', () => {
        sortField.value = sortSelect.value;

        ajaxRequest(filtersC);
      });
    };

    filtersC.addEventListener('submit', e =>{
      e.preventDefault();
      
      const errorInputs = filtersC.querySelectorAll('.custom-input.input-error');

      if (errorInputs.length == 0) {
        ajaxRequest(filtersC);
      }

      filterCollapser.hide()
    })

    resetBtn.addEventListener('click', e => {
      e.preventDefault();

      singleFilters.forEach(filter => {
        const filterResetBtn = filter.querySelector('.filter-single-remove'),
        filterFields = filter.querySelectorAll('input, textarea'),
        filterCounter = filter.querySelector('.filter-counter');

        filterFields.forEach(field => {
          field.checked = false;
          field.value = null;
          field.disabled = false;
        });
        
        filterSetActiveCounter(filterFields, filterCounter, filterResetBtn);
        filterSetMainCounter(singleFilters);
        checkAreaUnits(filterFields);
      });
    })
  
    singleFilters.forEach(filter => {
      const filterType = filter.dataset.type,
            filterResetBtn = filter.querySelector('.filter-single-remove'),
            filterExpand = filter.querySelector('.filter-single-inner-header'),
            filterFields = filter.querySelectorAll('input, textarea'),
            checkedFields = filter.querySelectorAll('input:not(.checkAll):checked'),
            checkAll = filter.querySelector('input.checkAll'),
            checkfilterFields = filter.querySelectorAll('input:not(.checkAll)'),
            filterCounter = filter.querySelector('.filter-counter'),
            counterValue = parseInt(filterCounter.textContent);

      if (checkAll && (checkedFields.length === checkfilterFields.length)) {
        checkAll.checked = true
      }

      if (counterValue) {
        filterExpand.click();
      }

      if (filterType === 'range') {
        filterFields.forEach(field => {
          field.addEventListener('change', () => {
            validateRangeInputs(filter);
          });
          validateRangeInputs(filter);
        });
      }
  
      filterResetBtn.addEventListener('click', () =>{
        filterFields.forEach(field => {
          field.checked = false;
          field.value = null;
          field.disabled = false;
        });

        filterSetActiveCounter(filterFields, filterCounter, filterResetBtn);
        filterSetMainCounter(singleFilters);
        checkAreaUnits(filterFields);
      });
  
      filterFields.forEach(field => {
        field.addEventListener('change', () => {
          if (field.classList.contains('checkAll')) {
            let action = field.checked ? true : false;

            filterFields.forEach(item => {
              item.checked = action;
            })
          }
          filterSetActiveCounter(filterFields, filterCounter, filterResetBtn);
          filterSetMainCounter(singleFilters);
          checkAreaUnits(filterFields);
        });
      });
  
      filterSetActiveCounter(filterFields, filterCounter, filterResetBtn);
      filterSetMainCounter(singleFilters);
      checkAreaUnits(filterFields);
    });

    inputs.forEach((input) => {
      handleInputEvent(input, filtersContainer);
    });
  })


  function filterSetActiveCounter(filterFields, filterCounter, filterResetBtn) {
    let counter = 0;

    filterFields.forEach(field => {
      if (
        (field.type == 'checkbox' && field.checked && !field.classList.contains('checkAll')) ||
        (field.type != 'checkbox' && field.value)
      ) counter++
    })

    if (counter) {
      filterCounter.textContent = counter;
      filterCounter.classList.remove('d-none');
      filterResetBtn.classList.remove('d-none');
    } else {
      filterCounter.textContent = '';
      filterCounter.classList.add('d-none');
      filterResetBtn.classList.add('d-none');
    }
  }

  function filterSetMainCounter(singleFilters) {
    mainCounter.forEach(item => {
      item.textContent = '';
      item.classList.add('d-none');
    });

    let groupCounter = 0;

    singleFilters.forEach(filter => {
      const filterFields = filter.querySelectorAll('input, textarea');

      const checkGroup = Array.from(filterFields).some(field => 
        (field.type == 'checkbox' && field.checked && !field.classList.contains('checkAll')) ||
        (field.type != 'checkbox' && field.value)
      );

      if (checkGroup) {
        groupCounter++

        mainCounter.forEach(item => {
          item.textContent = groupCounter;
          item.classList.remove('d-none');
        });
      }
    })
  }

  function checkAreaUnits(filterFields) {
    let areaUnits = [],
        label = document.querySelector(`.filter-single[data-slug="areaFrom|areaTo"] .filter-single-header-text`);

    filterFields.forEach(field => {

      if (field.dataset.areaunit && field.checked) {
        if (!areaUnits.includes(field.dataset.areaunit)) {
          areaUnits.push(field.dataset.areaunit);
        }
      }
    });

    if(areaUnits.length == 2 || areaUnits.length == 0) {
      label.textContent = globalTranslations.areaHaAr;
      return;
    }

    if (areaUnits.includes('m2')) {
      label.textContent = globalTranslations.areaM2;
    } else if (areaUnits.includes('ha')) {
      label.textContent = globalTranslations.areaHa;
    }
  }

  function validateRangeInputs(filter) {
    const rangeFrom = filter.querySelector('input.from'),
          rangeTo = filter.querySelector('input.to'),
          rangeFromErr = filter.querySelector('input.from + .error-message'),
          rangeToErr = filter.querySelector('input.to + .error-message');

    const rangeFromVal = parseInt(rangeFrom.value),
          rangeToVal = parseInt(rangeTo.value);

    if (rangeFromVal > rangeToVal) {
      rangeFrom.parentNode.classList.add('input-error');
    } else {
      rangeFrom.parentNode.classList.remove('input-error');
    }
  }

  const clearEmptyFormData = (formData) => {
    for(var [key, value] of Array.from(formData.entries())) {
      if(value === '' || value === null || value === undefined) {
        formData.delete(key);
      }
  }

    return formData;
  }

  async function ajaxRequest(filtersC) {
    const formData = new URLSearchParams(clearEmptyFormData(new FormData(filtersC))).toString(),
          currentUrl = window.location.pathname,
          newUrl = `${currentUrl}?${formData}`;

    window.history.pushState({path: newUrl}, '', newUrl);

    const request = await axios.get(`/api/v1/real-estates?${formData}`);

    if (!request.data) {
      return;
    }

    const postsContainer = document.querySelector('.real-estate-main-posts'),
          modalPosts = document.querySelector('#real-estate-full-map'),
          modalPostsContainer = modalPosts.querySelector('.real-estate-posts'),
          pagination = document.querySelector('.real-estate-pagination'),
          noPosts = document.querySelector('.no-posts'),
          map = document.querySelector('.google-map.real-estate-full-map');

    pagination.innerHTML = '';
    noPosts.classList.add('d-none');

    postsContainer.innerHTML = '';
    modalPostsContainer.innerHTML = '';
    map.innerHTML = '';

    if (request.data.message?.posts.length) {
      request.data.message.posts.forEach(item => {
        if (!item) {
          return;
        }
        const parser = new DOMParser(),
              parsedHtml = parser.parseFromString(item.template, 'text/html'),
              body = parsedHtml.querySelector('body');

        const parserModal = new DOMParser(),
              parsedHtmlModal = parserModal.parseFromString(item.templateModal, 'text/html'),
              bodyModal = parsedHtmlModal.querySelector('body');

            if (item.map) {
              const marker = document.createElement('div');
                    marker.classList.add('google-map-marker', 'google-map-marker--real-estate-fullmap');
              
              if (item.map.lat) {
                marker.setAttribute('data-lat', item.map.lat);
              }

              if (item.map.lng) {
                marker.setAttribute('data-lng', item.map.lng);
              }

              if (item.title) {
                marker.setAttribute('data-title', item.title);
              }

              map.appendChild(marker);
            }
        postsContainer.appendChild(body.firstChild);
        modalPostsContainer.appendChild(bodyModal.firstChild);
      });
    } else {
      noPosts.classList.remove('d-none');
    }

    if (request.data.message.pagination) {
      request.data.message.pagination.forEach(item => {
        const parser = new DOMParser(),
              parsedHtml = parser.parseFromString(item, 'text/html'),
              body = parsedHtml.querySelector('body');

        const listElement = document.createElement('li');
              listElement.appendChild(body.firstChild);

        pagination.appendChild(listElement);
      });
    }

    initMap();

    return new Promise((resolve, reject) => {
      resolve();
    });
  }

  const expandOptionsBtns = document.querySelectorAll('.filter-expand-options');

  expandOptionsBtns.forEach(button => {
    const expandedLabel = button.querySelector('.expanded');
    const notExpandedLabel = button.querySelector('.not-expanded');

    button.addEventListener('click', () => {
      if (notExpandedLabel.classList.contains('d-none')) {
        notExpandedLabel.classList.remove('d-none');
        expandedLabel.classList.add('d-none');
      } else {
        notExpandedLabel.classList.add('d-none');
        expandedLabel.classList.remove('d-none');
      }
    });
  });

  const mobileTrigger = document.querySelector('.filter-main-header.mobile'),
        fContainer = document.querySelectorAll('.filter');

  mobileTrigger?.addEventListener('click', e => {
    const expanded = mobileTrigger.getAttribute('aria-expanded'),
        action = expanded == 'true' ? 'add' : 'remove';

      fContainer.forEach(item => {
        item.classList[action]('shadow');
      })
  });
}
